import { userService } from '@/services/api/user.service';
import i18n from '@/i18n';
import { sharedHelper, alertHelper } from '@/utils';
import { userModel } from '@/models/api/user.model';

export const state = {
    list: {
        data: [],
        pagination: {
            pageNumber: 0,
            pageSize: 0,
            lastPage: 0,
            tableRowsCount: 0
        },
    },
    details: {},
    status: {
        list: true,
        detail: true,
        save: true,
    },
};

export const USER_MODULE = "api/user";

// ACTIONS
export const GET_ALL_USER = 'getAllUser';
export const CREATE_USER = 'createUser';
export const GET_USER = 'getUser';
export const UPDATE_USER = 'updateUser';
export const UPDATE_USER_STATUS = 'updateUserStatus';
export const UNLOCK_USER = 'unlockUser';
export const SOFT_DELETE_USER = 'softDeleteUser';

// MUTATIONS
const REQUESTING = "requesting";
const ALL_USER_SUCCESS = "allUserSuccess";
const SUCCESS = "commonSuccess";
const FAILURE = "commonFailure";
const GET_USER_SUCCESS = "getUserSuccess";

export const actions = {
    [GET_ALL_USER]({commit}, {filter}) {
        commit(REQUESTING, 'list');
        userService
            .getAll(filter)
            .then((result) => {
                commit(ALL_USER_SUCCESS, {data: result});
                commit(SUCCESS);
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
    [CREATE_USER]({commit, dispatch}, {data, filter}) {
        commit(REQUESTING, 'save');
        return userService
            .store(data)
            .then((result) => {
                alertHelper.alertSuccess({message: i18n.t('label.createX', [i18n.t('message.success')])});
                commit(SUCCESS);
                dispatch(GET_ALL_USER, {filter});
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
    [GET_USER]({commit}, {uuid}) {
        commit(REQUESTING, 'detail');
        return userService
            .show(uuid)
            .then((result) => {
                commit(SUCCESS);
                commit(GET_USER_SUCCESS, result);
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
    [UPDATE_USER]({commit, dispatch}, {data, filter}) {
        commit(REQUESTING, 'save');
        return userService
            .update(data)
            .then((result) => {
                alertHelper.alertSuccess({message: i18n.t('label.updateX', [i18n.t('message.success')])});
                commit(SUCCESS);
                dispatch(GET_ALL_USER, {filter});
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });

    },
    [UPDATE_USER_STATUS]({dispatch, commit}, {filter, data}) {
        commit(REQUESTING, 'save');
        return userService
            .updateStatus(data)
            .then((result) => {
                alertHelper.alertSuccess({message: i18n.t(`${data.isActive==0 ? 'message.deleteXSuccess' : 'message.restoreXSuccess'}`, [])});
                commit(SUCCESS);
                dispatch(GET_ALL_USER, {filter});
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
    [UNLOCK_USER]({dispatch, commit}, {filter, data}) {
        commit(REQUESTING, 'save');
        return userService
            .unlock(data)
            .then((result) => {
                alertHelper.alertSuccess({message: i18n.t('message.unlockXSuccess', [])});
                commit(SUCCESS);
                dispatch(GET_ALL_USER, {filter});
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
    [SOFT_DELETE_USER]({dispatch, commit}, {filter, data}) {
        commit(REQUESTING, 'save');
        return userService
            .softDelete(data)
            .then((result) => {
                alertHelper.alertSuccess({message: i18n.t('message.deleteXSuccess')});
                commit(SUCCESS);
                dispatch(GET_ALL_USER, {filter});
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
};


export const mutations = {
    [ALL_USER_SUCCESS](state, {data}) {
        let user = data.data || [];
        state.list.data = user;
        state.list.pagination = sharedHelper.apiPaginationAdapter(data.pagination);

        if(data.success) {
            state.list.data = user.map(item => userModel(item));
        }
    },
    [GET_USER_SUCCESS](state, data) {
        state.details = userModel(data.data);
    },
    [FAILURE](state) {
        state.status = {
            list: true,
            detail: true,
            save: true,
        };
    },
    [REQUESTING](state, type) {
        state.status[type] = false;
    },
    [SUCCESS](state) {
        state.status = {
            list: true,
            detail: true,
            save: true,
        };
    },
};
